import {SignUpForm} from 'components/template/SignUpForm'

export const SignUp = () => {
  return (
    <div className="text-gray-800 flex flex-col justify-center items-center">
      <SignUpForm />
    </div>
  )
}
